import { useEffect, useState } from "react";

const CHECKS = [
  "Workstation prepared under facility procedure",
  "Required protective equipment checked",
  "Tools checked and ready",
  "Work surface checked and ready",
];

export function HygieneModal({
  open, onConfirm, onCancel,
}: { open: boolean; onConfirm: () => void; onCancel: () => void }) {
  const [checked, setChecked] = useState<boolean[]>(() => CHECKS.map(() => false));

  useEffect(() => {
    if (open) setChecked(CHECKS.map(() => false));
  }, [open]);

  if (!open) return null;
  const allChecked = checked.every(Boolean);
  const toggle = (i: number) => setChecked((cur) => cur.map((v, idx) => (idx === i ? !v : v)));

  return (
    <div className="modal-overlay">
      <div className="panel modal-card">
        <h2 style={{ textTransform: "none", letterSpacing: 0, color: "var(--foreground)", fontSize: "1.15rem" }}>
          Before you start
        </h2>
        <p className="small muted" style={{ marginTop: 4 }}>Personal readiness reminder. Facility records are saved in Room.</p>
        {CHECKS.map((label, i) => (
          <label key={label} className="check-row">
            <input type="checkbox" checked={checked[i]} onChange={() => toggle(i)} />
            <span>{label}</span>
          </label>
        ))}
        <div className="btn-row" style={{ marginTop: 14 }}>
          <button type="button" className="btn btn-ghost" onClick={onCancel}>Back</button>
          <button
            type="button" className="btn btn-primary" data-testid="hygiene-confirm"
            disabled={!allChecked} onClick={onConfirm}
          >
            Ready — start
          </button>
        </div>
      </div>
    </div>
  );
}
